
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import IconColors from '@/config/IconColors';

@Component({
  name: 'ColorPicker'
})
export default class ColorPicker extends Vue {
  @Prop()
  private value: string;

  @Prop()
  private disabled: boolean;

  get valueColor() {
    return this.value && IconColors.codeToName(this.value);
  }

  get colors() {
    return IconColors.names;
  }

  selectColor(color) {
    if (!this.disabled) {
      this.$emit('input', IconColors.nameToCode(color));
    }
  }
}
